module.exports = __webpack_public_path__ + "img/5-2.6c11fd39.svg";